import { UserPermissionsAccessType } from 'store';

export const TYPE_PERMISSION_READ: UserPermissionsAccessType = 'read';
